import { useNavigate } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { PHASES, WIZARD_STEPS, stepPath } from '../../data/wizardSteps';
import { usePortal } from '../../contexts/PortalContext';

interface StepTimelineProps {
  currentStepId: string;
}

export function StepTimeline({ currentStepId }: StepTimelineProps) {
  const { completedSteps, isRequired } = usePortal();
  const navigate = useNavigate();

  /* Optional sections count towards progress; nothing in them was compulsory. */
  const doneCount = WIZARD_STEPS.filter(
    (step) => completedSteps.includes(step.id) || !isRequired(step.id)
  ).length;
  const total = WIZARD_STEPS.length;

  return (
    <nav className="timeline-rail" aria-label="Proposal sections">
      <div className="timeline-progress">
        <div className="timeline-progress-head">
          <span className="timeline-progress-label">Your progress</span>
          <span className="timeline-progress-count">
            {doneCount}/{total}
          </span>
        </div>
        <div
          className="progress-bar"
          role="progressbar"
          aria-valuenow={doneCount}
          aria-valuemin={0}
          aria-valuemax={total}
          aria-label="Sections completed">
          
          <span style={{ width: `${doneCount / total * 100}%` }} />
        </div>
      </div>

      <div className="timeline-scroll">
        {PHASES.map((phase) => {
          const steps = WIZARD_STEPS.filter((step) => step.phase === phase.n);
          return (
            <section className="timeline-phase" key={phase.n}>
              <h2 className="timeline-phase-title">
                <span className="timeline-phase-n">{phase.n}</span>
                {phase.label}
              </h2>
              <ol className="timeline-list">
                {steps.map((step) => {
                  const optional = !isRequired(step.id);
                  const done = completedSteps.includes(step.id);
                  const current = step.id === currentStepId;
                  const state = current ? 'current' : done ? 'done' : 'pending';
                  return (
                    <li className={`timeline-item timeline-item--${state}`} key={step.id}>
                      <button
                        type="button"
                        className="timeline-link"
                        aria-current={current ? 'step' : undefined}
                        onClick={() => navigate(stepPath(step.id))}>
                        
                        <span className="timeline-dot" aria-hidden="true">
                          {done ? <CheckIcon size={12} /> : null}
                        </span>
                        <span className="timeline-text">
                          <span className="timeline-label">{step.label}</span>
                          {current ?
                          <span className="timeline-sub">{step.summary}</span> :
                          optional ?
                          <span className="timeline-sub">Optional</span> :
                          null}
                        </span>
                      </button>
                    </li>);

                })}
              </ol>
            </section>);

        })}
      </div>
    </nav>);

}